export default __webpack_public_path__ + "static/media/cover.a045b957.jpeg";